import { Component, Input, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { FiatTransaction } from "@models/transaction";
import { ModalService } from "@core-services/modal.service";
import { Observable } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { distinctUntilChanged, filter } from "rxjs/operators";
import { PaysafeStandardService } from "@modules/paysafe/services/paysafe-standard.service";
import { CheckoutDepositData } from "@modules/checkout/entities/checkout.deposit-data";

@UntilDestroy()
@Component({
	selector: "app-paysafe-3ds-modal",
	templateUrl: "./paysafe-3ds-modal.component.html",
	styleUrls: ["./paysafe-3ds-modal.component.scss"],
	standalone: false
})
export class Paysafe3DSModalComponent implements OnInit, OnDestroy {
	public save: boolean = false;
	private escListener: () => void;
	private expired$: Observable<boolean> = this.paysafeService.expired$;

	public constructor(
		private paysafeService: PaysafeStandardService,
		private modalService: ModalService,
		private renderer: Renderer2
	) {}

	private _transaction: FiatTransaction = null;
	@Input()
	public isCheckout: boolean = false;
	@Input() checkoutDepositData: CheckoutDepositData = null;

	@Input()
	public set transaction(tx: FiatTransaction) {
		this._transaction = tx;
		this.paysafeService.setTransactionDetails(this._transaction);
		// Extracting last 2 needed params from PaymentLink which follows "v1/credit-card-deposit/:transactionId:/:token" schema.
		const [transactionId, token] = this._transaction.getPaymentLink().split("/").slice(-2);
		this.paysafeService.setToken(token);
		this.paysafeService.setTransactionId(transactionId);
	}

	public ngOnInit(): void {
		this.handleExpirationScreen();
		this.handleEscListenerChanges();
	}

	public ngOnDestroy(): void {
		this.disableEscKey();
	}

	public handleCCSaveChange($event: boolean): void {
		this.paysafeService.changeSave($event);
	}

	public onHeaderButtonClick(): void {
		this.close();
	}

	private enableEscKey(): void {
		this.escListener = this.renderer.listen("window", "keydown.esc", ($event) => {
			this.close();
		});
	}

	private disableEscKey(): void {
		this.escListener();
	}

	private close(): void {
		this.paysafeService.onUserProcessClose();
		this.modalService.getCurrentModal().dismiss();
	}

	private handleExpirationScreen(): void {
		this.expired$
			.pipe(
				untilDestroyed(this),
				filter((expired: boolean) => expired)
			)
			.subscribe(() => this.paysafeService.displayExpiredScreen());
	}

	private handleEscListenerChanges(): void {
		this.paysafeService.pending$
			.pipe(distinctUntilChanged(), untilDestroyed(this))
			.subscribe((pending: boolean) => {
				pending ? this.disableEscKey() : this.enableEscKey();
			});
	}
}
